window.onload = function () {
  // const body = document.querySelector('.body');
  // const burgerMenu = document.querySelector('.mobile-menu-button');
  // const menu = document.querySelector('.header .right-content');
  // const contactForm = document.querySelector('.contact-form');
  //
  // if (burgerMenu && menu) {
  //   burgerMenu.onclick = () => {
  //     body.classList.toggle('open-menu');
  //     burgerMenu.classList.toggle('open');
  //     menu.classList.toggle('open');
  //   }
  // }
  //
  // if (contactForm) {
  //   contactForm.onclick = () => {
  //     body.classList.remove('open-menu');
  //     burgerMenu.classList.remove('open');
  //     menu.classList.remove('open');
  //   }
  // }

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      });
    });
  });
}

$(document).ready(() => {
  $('.header-content2').css("display","none");
  $(".header-button").click(function () {
    $('.header-content2').slideUp();
    $('body').removeClass('hidden');
    $('#hamburger').removeClass('opened');
  });
  $("#hamburger").click(function () {
    $('.header-content2').slideToggle();
    $('body').toggleClass('hidden');
    $(this).toggleClass('opened');
  });
});
